import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";

const ReturnPolicy = () => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  function getBaseDomain(hostname) {
    const parts = hostname.split(".");
    if (parts.length >= 2) {
      return parts.slice(-2).join(".");
    }
    return hostname;
  }
  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setMessage(
      "Thank you for subscribing! 🎉 You'll now receive our latest offers and updates."
    );
    setEmail("");
    setSubscribed(true);
  };
  const siteName = window.location.hostname.replace("www.", "").split(".")[0];

  return (
    <Container id="main" role="main">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title mt-3">
          <div className="container mx-auto px-4 py-8">
            <h3 className="" style={{ fontWeight: 600, fontSize: "22px" }}>
              Return, Replacement & Refund Policy
            </h3>

            <p className="mb-4">
              At {siteName}, we aim to ensure customer satisfaction by offering
              a clear and fair return and refund process.
            </p>

            <h3 className=" mb-2" style={{ fontWeight: 600, fontSize: "22px" }}>
              Return Eligibility
            </h3>
            <ul className="list-disc list-inside mb-4">
              <li>
                Products are eligible for return or replacement{" "}
                <strong>within 7 days of delivery.</strong>
              </li>
              <li>
                Returns are accepted{" "}
                <strong>
                  only for damaged, defective, or incorrect items.
                </strong>
              </li>
              <li>
                Items must be unused, in original condition, with tags and
                original packaging.
              </li>
              <li>Proof of purchase is required.</li>
              <li>
                {" "}
                An{" "}
                <strong>
                  unboxing video is required only to verify damage or incorrect
                  items.
                </strong>
              </li>
            </ul>
            <p className="mb-4">
              To initiate a return or replacement, please contact us at{" "}
              <strong>support@{getBaseDomain(window.location.hostname)}</strong>{" "}
              with your order number and issue details.
            </p>
            <hr />
            <h3 className=" mb-2" style={{ fontWeight: 600, fontSize: "22px" }}>
              Return Address:
            </h3>
            <address className="mb-4 not-italic leading-relaxed">
              {process.env.REACT_APP_ADDRESS.split(",").map(
                (line, index, arr) => (
                  <div key={index}>
                    {line.trim()}
                    {","}
                  </div>
                )
              )}
            </address>

            <p className="mb-4">
              Items sent without prior return approval will not be accepted.
            </p>
            <hr />
            <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "22px" }}>
              Replacement Policy
            </h3>

            <ul className="list-disc list-inside mb-4">
              <li>
                If your return request is approved, a replacement will be
                shipped within <strong>3 business days</strong> after
                verification.
              </li>
              <li>
                Replacement delivery timelines may vary based on location.
              </li>
            </ul>
            <hr />
            <h3 className="" style={{ fontWeight: 600, fontSize: "22px" }}>
              Refund Policy
            </h3>
            <ul className="list-disc list-inside mb-4">
              <li>
                Refunds are issued in eligible cases, including situations where <strong>
                replacement is not possible.</strong>
              </li>
              <li>
                Once a refund is approved, the amount will be credited to the{" "}
                <strong>original payment method</strong> within{" "}
                <strong>7–10 business days</strong>.
              </li>
              <li>Bank processing times may vary.</li>
              <li>{siteName} is responsible for processing approved refunds in accordance with this policy.</li>
            </ul>
            <hr />
            <h3 style={{ fontWeight: 600, fontSize: "22px" }}>
              Non-Returnable Items
            </h3>
            <ul className="list-disc list-inside mb-4">
              <li>Bulk orders</li>
              <li>
                Discounted or promotional items (unless damaged or defective)
              </li>
            </ul>
            <hr />
            <h3 style={{ fontWeight: 600, fontSize: "22px" }}>
              Damaged or Incorrect Items
            </h3>
            <p>
              Please inspect your order upon delivery and contact us immediately
              if the product is damaged, defective, or incorrect so we can
              resolve the issue promptly.
            </p>
            <p>
              For any questions related to returns or refunds, contact{" "}
              <strong>
                support@{getBaseDomain(window.location.hostname)}.
              </strong>
            </p>
            <Form
              method="post"
              id="footer-newsletter"
              acceptCharset="UTF-8"
              className="my-3"
              onSubmit={handleSubscribe}
            >
              <input type="hidden" name="form_type" value="customer" />
              <input type="hidden" name="utf8" value="✓" />
              <input type="hidden" name="contact[tags]" value="newsletter" />

              <Form.Control
                size="lg"
                type="email"
                placeholder="Enter email"
                className="mb-3"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              {!subscribed && (
                <Button
                  type="submit"
                  variant="dark"
                  className="mt-3"
                  style={{
                    background: "var(--them-color)",
                    borderColor: "var(--them-color)",
                  }}
                >
                  Subscribe
                </Button>
              )}

              {message && (
                <p
                  style={{ color: "green", marginTop: "10px", fontWeight: 500 }}
                >
                  {message}
                </p>
              )}
            </Form>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ReturnPolicy;
